import { z } from 'zod';
export const platformSchema = z.enum([
    'linkedin',
    'twitter',
    'facebook',
    'instagram',
    'tiktok',
    'youtube',
    'threads',
    'pinterest',
]);
export const characterLimits = {
    linkedin: 3000,
    twitter: 280,
    facebook: 63206,
    instagram: 2200,
    tiktok: 2200,
    youtube: 5000,
    threads: 500,
    pinterest: 500,
};
export const roleSchema = z.enum(['owner', 'admin', 'editor', 'reviewer', 'viewer']);
export const planSchema = z.enum(['starter', 'growth', 'scale']);
export const idSchema = z.string().uuid();
export const cursorPagination = z.object({
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(200).default(50),
});
export const paginatedResponse = (item) => z.object({
    data: z.array(item),
    next_cursor: z.string().nullable(),
});
export const errorResponse = z.object({
    type: z.string(),
    title: z.string(),
    status: z.number().int(),
    detail: z.string().optional(),
    instance: z.string().optional(),
    remediation: z.string().optional(),
});
export const isoDateTime = z
    .string()
    .datetime({ offset: true })
    .describe('ISO 8601 date-time with offset, e.g. 2026-04-26T14:30:00Z');
//# sourceMappingURL=common.js.map